import { render, staticRenderFns } from "./TraxTrainingProgramEditItems.vue?vue&type=template&id=229f4054"
import script from "./TraxTrainingProgramEditItems.vue?vue&type=script&lang=js"
export * from "./TraxTrainingProgramEditItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports